import { render, staticRenderFns } from "./newJxjApply.vue?vue&type=template&id=44981041&scoped=true&"
import script from "./newJxjApply.vue?vue&type=script&lang=js&"
export * from "./newJxjApply.vue?vue&type=script&lang=js&"
import style0 from "./newJxjApply.vue?vue&type=style&index=0&id=44981041&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44981041",
  null
  
)

export default component.exports